const SANCTION_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,6}))?)?$/;

export function isValidSanctionDate(value: string): boolean {
  const match = SANCTION_DATE_PATTERN.exec(value);
  if (!match) return false;

  const [, yearText, monthText, dayText, hourText, minuteText, secondText] = match;
  const year = Number(yearText);
  const month = Number(monthText);
  const day = Number(dayText);
  const daysInMonth = [31, year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  return year > 0 && month >= 1 && month <= 12 && day >= 1 && day <= daysInMonth[month - 1]
    && (hourText === undefined || (Number(hourText) <= 23 && Number(minuteText) <= 59 && Number(secondText) <= 59));
}

export function sanctionDateOrderKey(value: string): string {
  if (value.length === 10) return `${value}T00:00:00.000000`;
  const [seconds, fraction = ''] = value.split('.');
  return `${seconds}.${fraction.padEnd(6, '0')}`;
}
